import { Result } from 'src_common/common/mobx-utils/Form2/FormModel';

export const validateLength =
    (length: number, message?: string) =>
    (value: string): Result<string> => {
        if (value.length > length) {
            return Result.createError(typeof message === 'string' ? message : `Max length is ${length}`);
        }
        return Result.createOk(value);
    };
export const validateLengthRange =
    ({ min, max, message }: { min?: number; max?: number; message?: string }) =>
    (value: string): Result<string> => {
        if (typeof min === 'undefined' && typeof max === 'number' && value.length > max) {
            return Result.createError(`Max length is ${max}`);
        }

        if (typeof max === 'undefined' && typeof min === 'number' && value.length < min) {
            return Result.createError(`Min length is ${min}`);
        }

        if (typeof min === 'number' && typeof max === 'number' && (value.length > max || value.length < min)) {
            return Result.createError(
                typeof message === 'string' ? message : `Length should be between ${min} and ${max}`
            );
        }
        return Result.createOk(value);
    };

export const validateExpectNumber = (value: string): Result<number | null> => {
    const valueNumber = parseInt(value, 10);

    if (isNaN(valueNumber)) {
        return Result.createError('Number expected');
    }

    return Result.createOk(valueNumber);
};

export const validateListOfNumbersWithLimit =
    (limit: number) =>
    (value: string): Result<string> => {
        if (value === '') {
            return Result.createOk(value);
        }

        if (value.includes(' ')) {
            return Result.createError('Do not use space.');
        }

        if (value.includes('.')) {
            return Result.createError('Do not use dot.');
        }

        const stringValueList = value.replace(/\n/g, ',').split(',');
        const wrongStringsList = [];
        const correctNumbers: Set<number> = new Set();

        for (const stringValue of stringValueList) {
            if (stringValue.length > 0) {
                const numberValue = parseInt(stringValue, 10);

                if (isNaN(numberValue) || numberValue.toString().length !== stringValue.length) {
                    wrongStringsList.push(stringValue);
                } else {
                    correctNumbers.add(numberValue);
                }
            }
        }

        if (wrongStringsList.length > 0) {
            return Result.createError(`Wrong numbers: ${wrongStringsList.join(', ')}`);
        }

        if (correctNumbers.size > limit) {
            return Result.createError(`Too many numbers. Limit is: ${limit}`);
        }

        const resultValue = Array.from(correctNumbers).join(',').toString();

        return Result.createOk(resultValue);
    };

export const validAllowedCharacters =
    (allowedRegexp: RegExp, message: string) =>
    (value: string): Result<string> => {
        if (value.match(allowedRegexp) === null) {
            return Result.createError(message);
        }
        return Result.createOk(value);
    };

export const validIsUnique =
    <T>(getValues: () => Array<T>) =>
    (value: T): Result<T> => {
        const values = getValues();
        console.debug(values, value);
        const uniqueValues = values.filter((v) => v === value && value !== '');
        if (uniqueValues.length > 1) {
            return Result.createError(`The value should be unique`);
        }
        return Result.createOk(value);
    };
